import { DataModel } from "common/models/utility-models/base-model";

export class InternshipReportsModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedStatus: string = '';
    selectedCompany: string = '';
    selectedYear: string = '';
}